const auth = [
  { email: 'nmhaof@gmail.com', classId: [], limited: false },
  { email: 'tungnt@softech.vn', classId: [], limited: false },
  { email: 'testitdn@gmail.com', classId: [], limited: false },
  { email: 'admin@gmail.com', classId: [], limited: false },
  { email: 'joya.dolly@gmail.com', classId: [], limited: false }, // Tài khoản cái có 1 route riêng, cách hiển thị như của học sinh.
  { email: 'teacher.allbooks@gmail.com', classId: [], limited: false }, // Tài khoản cái có 1 route riêng, cách hiển thị như của học sinh.
  { email: 'phannam12@gmail.com', classId: [6], limited: true },
  { email: 'hocsinhlop1@gmail.com', classId: [1], limited: true },
  { email: 'hocsinhlop2@gmail.com', classId: [2], limited: true },
  { email: 'hocsinhlop3@gmail.com', classId: [3], limited: true },
  { email: 'hocsinhlop4@gmail.com', classId: [4], limited: true },
  { email: 'hocsinhlop5@gmail.com', classId: [5], limited: true },
  // { email: 'phucnh@phuongnam.edu.vn', classId: [], limited: false },
  // { email: 'truyenthong@phuongnam.edu.vn', classId: [], limited: false },

  // { email: 'chuyenmonsta@phuongnam.edu.vn', classId: [], limited: false },
  // { email: 'trannguyenphuongthuy80@gmail.com', classId: [], limited: false },

  // // cấp trung học
  // { email: 'phatch@hcmeu.edu.vn', classId: [], limited: false },
  // { email: 'vohominhtrinh@gmail.com', classId: [], limited: false },
  // { email: 'huynhdonghai@gmail.com', classId: [], limited: false },
  // { email: 'tnttlan.lqd@hcm.edu.vn', classId: [], limited: false },
  // { email: 'phamnasil@gmail.com', classId: [], limited: false },
  // { email: 'xuanvv@phuongnam.edu.vn', classId: [], limited: false },
  // { email: 'nguyenminhtri19942013@gmail.com', classId: [], limited: false },
  // { email: 'dttvi.c2nntp@hcm.edu.vn', classId: [], limited: false },
  // { email: 'linhntn@phuongnam.edu.vn', classId: [], limited: false },

  // // cấp tiểu học
  // { email: 'trangnhd@phuongnam.edu.vn', classId: [], limited: false },
  // { email: 'lehongthai.dth@gmail.com', classId: [], limited: false },
  // { email: 'hochau3101@gmail.com', classId: [], limited: false },
  // { email: 'leviettien1979@gmail.com', classId: [], limited: false },
  // { email: 'mynguyen28@yahoo.com', classId: [], limited: false },
  // { email: 'junebui.2007@gmail.com', classId: [], limited: false },
  // { email: 'hongvien07@gmail.com', classId: [], limited: false },
  // { email: 'windylananh@gmail.com', classId: [], limited: false },
  // { email: 'nguyenlan3788@gmail.com', classId: [], limited: false },
  // { email: 'xuanvuongho@gmail.com', classId: [], limited: false },
  // { email: 'huongdvx@phuongnam.edu.vn', classId: [], limited: false },
];
export default auth;
